module.exports = window.__LR__.dependencies.load("flippers");